import { MaskLines } from "./Reveal";
import { motion } from "framer-motion";

// Consistent editorial page header used across interior pages.
export const PageHeader = ({ label, lines = [], intro, dark = false }) => (
  <section
    data-testid="page-header"
    className={`${dark ? "bg-bottle-green text-cream" : "bg-cream text-dark-text"} pt-36 md:pt-44 pb-16 md:pb-20`}
  >
    <div className="max-w-[1500px] mx-auto px-5 md:px-10">
      <motion.span
        initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.1 }}
        className={`label ${dark ? "text-cream/55" : "text-dark-text/50"}`}
      >
        {label}
      </motion.span>
      <h1>
        <MaskLines
          lines={lines}
          delay={0.15}
          className="block mt-6"
          lineClass="font-serif text-5xl md:text-7xl lg:text-8xl tracking-tight leading-[0.92]"
        />
      </h1>
      {intro && (
        <motion.p
          initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.5, duration: 0.7 }}
          className={`font-sans text-base md:text-lg leading-relaxed max-w-2xl mt-8 ${dark ? "text-cream/70" : "text-dark-text/70"}`}
        >
          {intro}
        </motion.p>
      )}
    </div>
  </section>
);
